import _ from 'lodash';

import { converter } from '../core/converter';
import infoBoard from '../core/infoboard';
import templates from '../core/templates';

class CompareInfo {
    constructor () {
        this.entry = { total: 0 };
        this.status = false;
    }

    static getInstance () {
        if (!CompareInfo._instance) {
            CompareInfo._instance = new CompareInfo();
        }

        return CompareInfo._instance;
    }

    init () {
    }

    _getContainer () {
        return infoBoard.createContainer({
            id: 'compare',
            name: 'Comparar',
            visible: !this.status
        });
    }

    _addMessage (container) {
        infoBoard.dataUnavailable({
            container,
            message: 'Sem ponto de comparação',
            image: 'no_store'
        });
        this.show(container);

        const template = $(templates('infoboard-content', {
            id: 'compare-collapse',
            actions: true
        }));
        $(container).append(template);
    }

    _addExportButton (container, resultType) {
        const actions = infoBoard.createActions({
            export: {
                value: true,
                label: 'Exportar Comparação'
            }
        }, 'Compare');
        actions.layout.appendTo(container);

        $(actions.export).on('click', function (e) {
            e.stopPropagation();
            converter.csv({
                name: 'comparar_pontos',
                type: resultType,
                data: this.entry
            });
        });
    }

    _createTable () {
        const container = document.getElementById('dash-container');
        container.innerHTML = infoBoard.createTitle('Comparação');

        const dataSource = [];
        _.forEach(this.entry, function (feature, name) {
            if (name === 'total') {
                return;
            }

            dataSource.push(feature.properties);
        });

        const content = $('<div>');
        content.appendTo(container);

        const table = $(content).kendoGrid({
            dataSource: {
                data: dataSource
            },
            scrollable: true,
            sortable: true,
            filterable: true,
            pageable: false,
            rowTemplate: this._rowTemplate(),
            columns: [
                {
                    field: 'Id',
                    width: '60px'
                },
                {
                    field: 'Nome'
                },
                {
                    field: 'Acesso'
                },
                {
                    field: 'Visibilidade'
                }
            ]
        });

        table.data('kendoGrid').table.addClass('compare-table');
    }

    _rowTemplate () {
        return kendo.template((`
        # var color1 = NeoGIG.View.Compare.getColor(Acesso) #
        /*r color3 = NeoGIG.View.Compare.getColor(Visibilidade) #*/
        <tr data-uid="#= Id #">
          <td>
            #: Id #
          </td>
          <td>
            #: Nome #
          </td>
          <td class="#: color1 #">
            #: Acesso #
          </td>
          <td class="#: color3 #">
            #: Visibilidade #
          </td>
        </tr>
    `));
    }

    // END: _rowTemplate = ->
    getColor (value) {
        switch (value) {
        case 1:
            return 'poor';
        case 2:
            return 'regular';
        case 3:
            return 'good';
        case 4:
            return 'very-good';
        default:
            return 'excellent';
        }
    }

    create () {
        const container = this._getContainer();
        container.innerHTML = '';
        return this._addMessage(container);
    }

    add (feature) {
        if (this.check(feature.properties.Id)) {
            return;
        }

        $('.no-point-selected').remove();
        this.entry[feature.properties.Id] = feature;

        if (this.entry.total >= 1) {
            $('.compare-submit').find('.submit').attr('disabled', false);
        }

        this.entry.total++;

        const options = {
            feature,
            index: 0,
            name: 'compare',
            container: this._getContainer(),
            controls: {
                trash: true
            }
        };

        const item = infoBoard.createItem(options);
        $('#compare-collapse').append(item.layout);

        item.btn.trash.on('click', e => {
            e.preventDefault();
            this.remove(feature);
        });
    }

    // END: add = (feature) ->
    remove (feature) {
        $(`#compare-title-${feature.properties.Id}`).closest('.panel-default').remove();
        $(`#compare-${feature.properties.Id}`).iCheck('uncheck');

        delete this.entry[feature.properties.Id];
        this.entry.total--;

        if (this.entry.total === 1) {
            $('.compare-submit').find('.submit').attr('disabled', true);
        }

        if (this.entry.total === 0) {
            return this._addMessage(this._getContainer());
        }
    }

    // END: remove = (feature) ->
    show (container, resultType) {
        // hide actions menu
        $(container).find('.panel-context').hide();

        this.entry.total = 0;

        if (this.status) {
            const disabled = this.entry.total === 0 ? 'disabled' : '';
            const template = templates('shared-action-bar', {
                cancel: true,
                compare: true,
                disabled
            });
            $(container).append(template);

            $(template).find('.action-submit').on('click', () => {
                this._createTable();
                infoBoard.toggleDashboard(true);
                this._addExportButton(container, resultType);
            });

            return $(template).find('.action-cancel').on('click', () => {
                _.forEach(this.entry, (value, key) => {
                    if (key === 'total') {
                        return;
                    }

                    this.remove(value);
                });
                this.status = false;
                $('.panel-context').show();
                $('.compare-submit').remove();
                $('input[name=compare]').each((ev, el) => $(el).iCheck('uncheck'));
                $('#infoboard-content').find('.panel-title').each((i, el) => $(el).velocity({ width: '100%' }));
            });
        }
    }

    getStatus () {
        return this.status;
    }

    setStatus (value) {
        this.status = value;
    }

    check (id) {
        return !!this.entry[id];
    }
}

export default CompareInfo;



// WEBPACK FOOTER //
// ./src/scripts/info/CompareInfo.js